import React from "react"
/* This example requires Tailwind CSS v2.0+ */
import XCircleIcon from "@heroicons/react/solid/XCircleIcon"

function classNames(...classes) {
  return classes.filter(Boolean).join(" ")
}

export default function Alert(props) {
  const { error, title, content, html, className } = props

  return (
    <div
      className={classNames("mx-auto my-12 px-4 sm:px-6 lg:px-8", className)}
    >
      <div className="rounded-md bg-red-50 p-4">
        <div className="flex w-full">
          <div className="flex-shrink-0">
            <XCircleIcon className="h-5 w-5 text-red-400" aria-hidden="true" />
          </div>

          <div className="ml-3 max-w-full	w-full">
            <h3 className="not-prose text-sm font-medium text-red-800">
              {title}
            </h3>
            {content && (
              <div className="mt-2 text-sm text-red-700">
                {Array.isArray(content) ? (
                  <ul role="list" className="list-disc pl-5 space-y-1">
                    {content?.map?.(line => (
                      <li>{line}</li>
                    ))}
                  </ul>
                ) : (
                  <div className="mt-2 text-sm text-red-700">
                    <p>{content}</p>
                  </div>
                )}
              </div>
            )}

            <div className="overflow-auto prose">{html && html}</div>
          </div>
        </div>
      </div>
    </div>
  )
}
